import type { RouteRecordRaw } from 'vue-router';

// Usage & Billing, native in v3 (ported out of the legacy sub). Overview + Usage
// tabs live inside BillingView. Route-gated on billing@all, matching the legacy
// /billing route's perms.
const billingRoutes: RouteRecordRaw[] = [
  {
    path: '/billing',
    name: 'billing',
    component: () => import('@/domains/billing/views/BillingView.vue'),
    meta: { renderer: 'native', perms: ['billing@all'] },
  },
];

export default billingRoutes;
